import React, {useEffect, useState} from "react";
import {getOpdReportFxn} from "../actions";
import {Card, DatePicker, InputBox, Select2, Table} from "../../../components/Elements/appUtils";
import moment from "moment";
import {PatientCategory} from "../../../components/_utils/appUtils";

const {RangePicker} = DatePicker;

const OpdReport = () => {
    const [reportData, setReportData] = useState([]);
    const [fromDate, setFromDate] = useState(moment().startOf("day"));
    const [toDate, setToDate] = useState(moment().endOf("day"));
    const [patientCategory, setPatientCategory] = useState(undefined);
    const [refreshKey, setRefreshKey] = useState(moment())
    const ranges = {
        Today: [moment().startOf("day"), moment().endOf("day")],
        "Last Week": [
            moment().subtract(1, "week").startOf("week"),
            moment().subtract(1, "week").endOf("week"),
        ],
        "Last 15 Days": [moment().subtract(14, "days"), moment().endOf("day")],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
    };

    const getReportFxn = async (from = fromDate, to = toDate) => {
        const params = {
            fromDate: moment(from),
            toDate: moment(to),
        };
        if (patientCategory) {
            params.patientCategory = patientCategory;
        }
        const {data} = await getOpdReportFxn(params);
        setReportData(data || []);
        setRefreshKey(moment())
    };

    // Initial load
    useEffect(() => {
        getReportFxn();
    }, [patientCategory]);

    // Reload on date change
    useEffect(() => {
        if (fromDate && toDate) {
            getReportFxn(fromDate, toDate);
        }
    }, [fromDate, toDate]);

    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Date",
            dataIndex: "_id",
            key: "_id",
        },
        {
            title: "Count",
            dataIndex: "count",
            key: "count",
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            render: (item) => {
                return item ? `Rs. ${item}` : null
            }
        },
        {
            title: "Records",
            dataIndex: "records",
            key: "records",
            width: "30%",
            render: (data) => {
                return (data && data.length) ? <div>
                    {data && data.length ? <div>
                        <ul className={'ul-sm'}>
                            {data.map((item) => {
                                return (
                                    item && item.amount ? <li key={item}>
                                        <span>{item.productName || "Unknown"} : </span>
                                        <strong>Rs. {item.amount}</strong>
                                        <strong>({item.count})</strong>
                                    </li> : null
                                )
                            })}
                        </ul>
                    </div> : null}
                </div> : null
            }
        }
    ];

    return (
        <Card title="Visit Report">
            <div className="row">
                <div className="col-md-6">
                    <InputBox title="Date">
                        <RangePicker
                            value={[fromDate, toDate]}
                            onChange={(val) => {
                                if (!val) return;
                                setFromDate(val[0]);
                                setToDate(val[1]);
                            }}
                            ranges={ranges}
                        />
                    </InputBox>
                </div>
                <div className="col-md-6">
                    <InputBox title="Patient Category">
                        <Select2
                            label={'Category'}
                            value={patientCategory}
                            options={PatientCategory}
                            keyAccessor={(x) => x.name}
                            valueAccessor={(x) => x.name}
                            onChange={(value) => {
                                setPatientCategory(value)
                            }}
                        />
                    </InputBox>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-12" key={reportData.length}>
                    <div className={'scrollable-table'} key={refreshKey}>
                        <Table
                            dataSource={reportData}
                            columns={columns}
                            rowKey="_id"
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default OpdReport;
